import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

export default class ComponentEmptyMessage extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    visible: PropTypes.bool,
  };

  static defaultProps = {
    visible: true,
  };

  render() {
    if (!this.props.visible) return null;
    const { text } = this.props;
    return (
      <div className={classNames('ComponentEmptyMessage')}>
        <p>{text}</p>
      </div>
    );
  }
}
